
export const DefaultHomeFleetLocation = {
  name: 'Default Fleet',
  lat: 40.678460811399354,
  lng: -73.9017671277291,
};
